import React from 'react';
import './Spinner.css';

const Spinner = () => {
  return (
    <div className='w-full h-full m-auto p-44'>
      <span className="loader"></span>
    </div>
  )
}

export default Spinner;